"use client";

import React, { createContext, useContext, useRef, RefObject } from 'react';

interface NavigationContextType {
  servicesRef: RefObject<HTMLHeadingElement>;
  industriesRef: RefObject<HTMLHeadingElement>;
  aboutRef: RefObject<HTMLHeadingElement>;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: React.ReactNode }) {
  const servicesRef = useRef<HTMLHeadingElement>(null);
  const industriesRef = useRef<HTMLHeadingElement>(null);
  const aboutRef = useRef<HTMLHeadingElement>(null);

  const value = {
    servicesRef,
    industriesRef,
    aboutRef,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
} 